// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Hash as RawHash } from "lucide-react";
export const Hash = /* @__PURE__ */ createIcon(RawHash, "Hash", 2);
